/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-25 14:13:47
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-29 14:42:18
 * @FilePath: /wemeet-admin-new/src/hooks/useExportDrawer.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import { ref } from 'vue'
import { dataGetB, dataExportB } from '@/api/exhibitionManage'
import { parseTime } from '@/utils'

export function useExportDrawer() {
  const visible = ref(false)
  const data = ref([])

  let cachedParams = null

  function open() {
    visible.value = true
  }

  function close() {
    visible.value = false
  }

  function generateExcel(params = cachedParams) {
    cachedParams = params
    if (!visible.value) open()
    dataExportB(params).then((res) => {
      if (res.code !== 200) return
      refreshExcel(params)
    })
  }

  function refreshExcel(params = cachedParams) {
    dataGetB(params).then((res) => {
      if (res.code !== 200) return
      data.value = res.data.map((e) => {
        e.createTime = parseTime(e.createTime)
        return e
      })
    })
  }

  return {
    data,
    visible,
    open,
    close,
    generateExcel,
    refreshExcel,
  }
}
